import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../ui/Dialog/DialogActions";
import Button from "../../../../../../ui/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/core/styles";
import { Alert, AlertTitle } from '@material-ui/lab';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  dialog: {
    width: "476px"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  }
})

const ApproveModal = ({   open,
                        reload,
                          handleClose,
                          handleConfirm,
                          isLoading,
                          classes,
                          programId,
                          modalText,
                          message
                        }) => {
  const [comment, setComment] = React.useState(null);

  const handleSendToApprove = async () => {
    handleConfirm && await handleConfirm(programId, comment);
    await reload();
    handleClose();
  };

  return (
    <div>
      <Dialog onClose={handleClose}
              aria-labelledby="customized-dialog-title"
              open={open}
              PaperProps={{
                className: classes.dialog
              }}>
        <div>
          <DialogTitle>Отправка на экспертизу</DialogTitle>
          <DialogContent>
            {message &&
            <Alert style={{marginBottom: "16px"}} severity="info">
              <AlertTitle><strong>Внимание</strong></AlertTitle>
              {message}
            </Alert>}

            <Typography className={classes.heading}>
              {modalText}
            </Typography>

            <TextField
              name="comment"
              multiline
              label="Комментарий специалиста"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              InputLabelProps={{
                shrink: true
              }}
              style={{ width: "100%", marginTop: "24px" }}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose}
                    loading={isLoading}>Отмена</Button>
            <Button
              onClick={() => handleSendToApprove()}
              color="green"
              loading={isLoading}
            >
              Отправить
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(ApproveModal);
